const hapticStyles = {
    SUCCESS: "Success",
    WARNING: "Warning",
    ERROR: "Error",
};

export { hapticStyles };
